import React from 'react'

const RoundCrossIcon = ({ color = '#000', className = '' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 15.4 15.4">
      <g data-name="close-circle-svgrepo-com (3)">
        <path
          data-name="Path 934"
          d="M9 16a7 7 0 1 0-7-7 7.021 7.021 0 0 0 7 7z"
          style={{
            fill: 'none',
            stroke: color,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeWidth: '1.4px',
          }}
          transform="translate(-1.3 -1.3)"
        />
        <path
          data-name="Path 935"
          d="m9.17 14.83 5.66-5.66"
          transform="translate(-4.3 -4.3)"
          style={{
            fill: 'none',
            stroke: color,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeWidth: '1.4px',
          }}
        />
        <path
          data-name="Path 936"
          d="M14.83 14.83 9.17 9.17"
          transform="translate(-4.3 -4.3)"
          style={{
            fill: 'none',
            stroke: color,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeWidth: '1.4px',
          }}
        />
      </g>
    </svg>
  )
}

export default RoundCrossIcon
